import { createApp } from 'vue'
const app = createApp({})
import iosautofillfix from "./custom_directives";
app.directive('iosautofillfix', iosautofillfix);

import { createRouter, createWebHistory } from 'vue-router'
import { createStore } from 'vuex';
import moment from 'moment';
import Login from './components/Login/UserName.vue'
import Password from './components/Login/PasswordInput.vue'
import MagicLink from './components/Login/MagicLink.vue'
import ForgottonPasswordSetPassword from './components/Login/ForgottonPasswordSetPassword.vue'
import ForgottonPassword from './components/Login/ForgottonPassword.vue'
import SmsLogin from './components/Login/SmsLogin.vue'
import SmsLoginCode from './components/Login/SmsLoginCode.vue'
import SmsLoginPick from './components/Login/SmsLoginPick.vue'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/auth/login', name: 'login', component: Login, meta: { title: 'Login' }},
        { path: '/auth/login/password', name: 'password', component: Password, meta: { title: 'Login' }},
        { path: '/auth/login-link', name: 'magic-link', component: MagicLink, meta: { title: 'Login Link' }},
        { path: '/auth/forgotten-password/set-password/:code', name: 'forgotten-password-set-password', component: ForgottonPasswordSetPassword, meta: { title: 'Reset Password' }},
        {path: '/auth/forgotten-password', name: 'forgotten-password', component: ForgottonPassword, meta: { title: 'Reset Password' }},
        {path: '/auth/sms-login', name: 'sms-login', component: SmsLogin, meta: { title: 'SMS Login' }},
        {path: '/auth/sms-login/code', name: 'sms-login-code', component: SmsLoginCode, meta: { title: 'SMS Login' }},
        {path: '/auth/sms-login/pick', name: 'sms-login-pick', component: SmsLoginPick, meta: { title: 'SMS Login' }},
        {path: '/:pathMatch(.*)*', redirect: "/auth/login" }
    ],
    linkActiveClass: "active",
    linkExactActiveClass: "active"
});

router.beforeEach(function (to, from, next) {
    if(to.meta) {
        document.title = to.meta.title + ' - MyJobQuote'
    }
    next();
});


const store = createStore({
    state() {
        return {
            user: null,
            smsLoginUsers: null,
        };
    },
    mutations: {
        setUser (state, info) {
            state.user = info;
        },
        setSmsLoginUsers (state, info) {
            state.smsLoginUsers = info;
        },
    },
    getters: {},
});


app.use(router)
app.use(moment)
app.use(store)
app.mount('#app')
